
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { TarjetasOpciones } from "../../components";
import { LayoutUsuarios } from "../../layouts";
import { resetPasswordAdmin } from "../../../services";

import Swal from "sweetalert2";
import { useValidarRoles } from "../../../hooks";





export const OpcionesUsuario = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { permitirXRol } = useValidarRoles();
    const isAdmin = permitirXRol('SUPERADMIN');;
    const [cargando, setCargando] = useState(false)


    const handleNavegacion = (url) => {
        navigate(`/super/${url}/${id}`)
    }

    
    const handleResetPassword = async() => {
        const { isConfirmed } = await Swal.fire({
            title: 'Recuperar contraseña',
            text: `¿Está seguro de recuperar contraseña?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, recuperar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        await resetPasswordAdmin(id);
        setCargando(false);
    }


    const data = [
        {key:1, titulo:'Actualizar Usuario', function:handleNavegacion, icono:'editar', url:'actualizar-user'},
        {key:2, titulo:'Reset Password', function:handleResetPassword, icono:'password', url:'ddd'},
        {key:3, titulo:'OPs. de Cliente', function:handleNavegacion, icono:'producto', url:'ops-user'},
        ...(isAdmin 
            ? [ {key:4, titulo:'Configuraciones', function:handleNavegacion, icono:'settings', url:'settings'}, ] 
            : []),
    ];


    return (

        <LayoutUsuarios titulo='Información de Usuario'>
            <Grid container spacing={3} sx={{display:'flex', alignItems:'stretch', mt:1}}>
                {data.map( item => (
                    <TarjetasOpciones
                        key={item.key}
                        onClickHandler={item.function} 
                        url={item.url} 
                        icono={item.icono} 
                        titulo={item.titulo} 
                    />
                ))}
            </Grid>
        </LayoutUsuarios>

    )
}
